/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CoursePermMap } from './CoursePermMap';
import { CourseRole } from './CourseRole';
const ExtendedCourseRoleParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['perms', CoursePermMap],
    ['own', codecBoolean],
    ['count', codecNumber],
]), CourseRole);
export class ExtendedCourseRole extends CourseRole {
    static decode(input) {
        return ExtendedCourseRoleParser.decode(input).map(res => new ExtendedCourseRole(res));
    }
    static unsafeDecode(input) {
        return ExtendedCourseRole.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedCourseRoleParser.encode(data);
    }
    static schema() {
        return ExtendedCourseRoleParser.schema();
    }
}
